<template>
  <header :class="{ 'bd-banner-navbar': isBannerEnabled }"
    class="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar">
    <router-link class="navbar-brand mr-0 mr-md-2 ms-2 custom-brand" to="/" aria-label="testdrive">
      <img src="~@/assets/images/Opus_IVS_90h_extrawhite.png" alt="testdrive" style="height: 48px" />
      <span class="custom-app-title">Test Drive Copilot&trade;</span>
    </router-link>
    <div class="d-flex flex-row align-items-center">
      <div class="navbar-nav-scroll">
        <ul class="navbar-nav bd-navbar-nav flex-row">
          <li class="nav-item" v-for="n of nav" :key="n.name">
            <router-link exact class="nav-link" v-if="isAllowed(n.url)" :to="n.url" title="n.name">{{ n.name
            }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <ul class="navbar-nav me-3 ms-auto flex-row">
      <li v-if="profile.username" class="nav-item">
        <a id="profile" href="#" @click="showProfile" class="nav-link" title="profile">
          <i class="fas fa-user pr-1"></i>
          {{ username }}
        </a>
      </li>
      <li class="nav-item">
        <a id="logout" href="#" @click="logout" class="nav-link" title="logout">
          <i class="fas fa-sign-out-alt"></i>
          Logout
        </a>
      </li>
    </ul>
  </header>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { auth } from '@/stores'
export default {
  name: 'nav-top',
  data() {
    return {
      nav: [{ url: '/testdrives', name: 'Test Drive ROs' }, { url: '/dashboard', name: 'Dashboard' }]
    }
  },
  computed: {
    ...mapState(auth, ['profile', 'isAllowed']),
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    },
    username: {
      get() {
        let user = ''
        if (this.profile !== undefined && this.profile !== null) {
          user = this.profile.username
        }
        return user
      }
    }
  },
  methods: {
    ...mapActions(auth, ['clearToken']),
    showProfile() {
      this.$emit('showProfile')
    },
    logout() {
      this.clearToken()
      window.location.assign('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-brand {
  position: relative;
  background: #fff;
  padding: 5px;
}

.custom-app-title {
  position: absolute;
  bottom: 2px;
  left: 52px;
  color: #000;
  font-size: 0.7em;
  font-weight: 500;
}
</style>
